import React from "react";
import { connect } from "react-redux";
import LegalPdfViewer from "./LegalPdfViewer";

const PRIVACY_PDF_MAP = {
  pt: "EVIO_Politica de Privacidade_20261012 PT.pdf",
  en: "EVIO_Politica de Privacidade_20261012 EN.pdf",
  es: "EVIO_Politica_Privacidad_20261012 ES.pdf",
  fr: "EVIO_Politica de Privacidade_20261012 FR.pdf",
  ca: "EVIO_Politica de Privacidade_20261012 ES-CA.pdf",
  eu: "EVIO_Politica de Privacidade_20261012 ES-EU.pdf",
  gl: "EVIO_Politica de Privacidade_20261012 ES-GL.pdf",
  "es-ca": "EVIO_Politica de Privacidade_20261012 ES-CA.pdf",
  "es-eu": "EVIO_Politica de Privacidade_20261012 ES-EU.pdf",
  "es-gl": "EVIO_Politica de Privacidade_20261012 ES-GL.pdf",
};

const getPdfFileName = (locale) => {
  const pathLocale = (window.location.pathname.split("/")[1] || "").toLowerCase();
  const current = (locale || pathLocale || "en").toLowerCase();

  if (PRIVACY_PDF_MAP[current]) {
    return PRIVACY_PDF_MAP[current];
  }
  const primary = current.split(/[-_]/)[0];
  return PRIVACY_PDF_MAP[primary] || PRIVACY_PDF_MAP["en"];
};

const Privacy = ({ locale }) => {
  const fileName = getPdfFileName(locale);
  const pdfUrl = `${process.env.PUBLIC_URL || ""}/assets/privacy/${encodeURIComponent(fileName)}`;

  return (
    <LegalPdfViewer
      file={pdfUrl}
      loading="Loading privacy policy..."
      error="The privacy policy could not be loaded."
    />
  );
};

const mapStateToProps = (state) => ({
  locale: state.i18n ? state.i18n.locale : null,
});

export default connect(mapStateToProps)(Privacy);
